import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Briefcase, Archive } from 'lucide-react';
import { JOB_OPENINGS_TAB_VALUES } from '../constants';

export interface JobOpeningsTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: { label: string }[];
}

export const JobOpeningsTabs = ({ activeTab, onTabChange, tabs }: JobOpeningsTabsProps) => {
  return (
    <Box
      sx={{
        p: 0.5,
        bgcolor: 'grey.100',
        borderRadius: 2.5,
        display: 'inline-flex',
        border: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Stack direction="row" spacing={0.5}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.label;
          const isClosed = tab.label === JOB_OPENINGS_TAB_VALUES.CLOSED;
          const Icon = isClosed ? Archive : Briefcase;

          return (
            <Button
              key={tab.label}
              onClick={() => onTabChange(tab.label)}
              size="small"
              startIcon={<Icon size={15} />}
              sx={{
                px: 2,
                py: 0.75,
                borderRadius: 2,
                fontSize: '0.8125rem',
                fontWeight: isActive ? 600 : 500,
                textTransform: 'none',
                color: isActive
                  ? isClosed
                    ? 'error.main'
                    : 'success.dark'
                  : 'text.secondary',
                bgcolor: isActive ? 'background.paper' : 'transparent',
                boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
                '&:hover': {
                  bgcolor: isActive ? 'background.paper' : 'grey.200',
                  color: isActive
                    ? isClosed
                      ? 'error.main'
                      : 'success.dark'
                    : isClosed
                      ? 'error.main'
                      : 'text.primary',
                },
                transition: 'all 0.2s ease-in-out',
              }}
            >
              {tab.label}
            </Button>
          );
        })}
      </Stack>
    </Box>
  );
};
